/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/mine_dome': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M9 19h14v4H9zM7 17h18v1H7zM20 24a2 2 0 100 4 2 2 0 000-4zm-.042 3a1 1 0 110-2 1 1 0 010 2zM12.042 24a2 2 0 100 4 2 2 0 000-4zM12 27a1 1 0 110-2 1 1 0 010 2zM15 24h2v2h-2zM7 24h2v2H7zM23 24h2v2h-2zM11 16l5-5 5 5zM9 4h1v5H9z"/><path pid="1" d="M7 6h5v1H7zM24 10h1v3h-1z"/><path pid="2" d="M23 11h3v1h-3zM8.5 32H0v-8.5h1V31h7.5zM14.269 31h3.461v1h-3.461zM32 32h-8.5v-1H31v-7.5h1zM31 14.27h1v3.461h-1zM32 8.5h-1V1h-7.5V0H32zM14.27 0h3.461v1H14.27zM1 8.5H0V0h8.5v1H1zM0 14.269h1v3.461H0z"/>'
  }
})
